module.exports = __webpack_public_path__ + "img/camera.4dbc545a.svg";